import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastProvider, useMediaQuery } from '@repo/ui';
import EditorPage from '@/pages/EditorPage';
import DevEditorPage from '@/pages/DevEditorPage';
import MobileNotice from '@/components/MobileNotice';

/**
 * 에디터 셸은 데스크탑 전용이다 — `h-screen` 고정 2열에 드래그 편집이라
 * 좁은 폭에서는 우측 컬럼과 헤더 버튼이 화면 밖으로 나간다. 반응형으로
 * 접는 대신 이 폭에서는 안내를 보여주고 편집 UI 자체를 마운트하지 않는다
 * (pixi WebGL 컴포지터와 WebCodecs 디코더를 헛돌리지 않는 효과도 있다).
 *
 * 기준을 1024px 로 잡은 건 실측 결과다. 768px 에서는 헤더의 「전체·기본·확대」와
 * 「실행취소·다시실행」, 타임라인의 「확대·맞춤」이 전부 한 글자씩 세로로
 * 쪼개진다. 1024px 부터 전부 한 줄로 들어온다.
 */
const DESKTOP_MIN = '(min-width: 1024px)';

export default function App() {
  const isDesktop = useMediaQuery(DESKTOP_MIN);

  return (
    <ToastProvider>
      {isDesktop ? (
        <Routes>
          <Route path="/editor/dev" element={<DevEditorPage />} />
          <Route path="/editor/:projectId" element={<EditorPage />} />
          <Route path="*" element={<Navigate to="/editor/dev" replace />} />
        </Routes>
      ) : (
        <MobileNotice />
      )}
    </ToastProvider>
  );
}
